import { useTranslation } from 'react-i18next';
import { products as productMetas, productCategories } from '../data/productRegistry';

export function useLocalizedProducts() {
  const { t } = useTranslation('editor');
  return productMetas.map(({ slug }) => ({
    slug,
    name: t(`products.${slug}.name`),
    tagline: t(`products.${slug}.tagline`),
    description: t(`products.${slug}.description`),
    features: t(`products.${slug}.features`, { returnObjects: true }) as { title: string; description: string }[],
    highlights: t(`products.${slug}.highlights`, { returnObjects: true }) as string[],
    pricingNote: t(`products.${slug}.pricingNote`),
  }));
}

export function useLocalizedDeployments() {
  const { t } = useTranslation('editor');
  const ids = ['sovereign-cloud', 'on-premise', 'standalone', 'saas'];
  return ids.map((id) => ({
    id,
    name: t(`deployments.${id}.name`),
    description: t(`deployments.${id}.description`),
    features: t(`deployments.${id}.features`, { returnObjects: true }) as string[],
  }));
}

export function useLocalizedCategories() {
  const { t } = useTranslation('editor');
  return productCategories.map(({ id }) => ({ id, label: t(`categories.${id}`) }));
}
